import { React, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { language } from '../../stores/slices/languageSlice'
import { setConditionalRoute } from '../../stores/slices/generalConfiguration/routeRestrictionSlice'
import { Modal } from "antd"
import { resetPreQualValidate } from '../../stores/slices/preQual/preQualValidateSlice'
import { resetTreatingPhysician } from '../../stores/slices/appIntake/searchProviderSlice'
import maskData from '../../utilities/validations/maskData'
import { fetchViewAppDetails, getMemberDetails, resetAppViewDetails, resetInitialTab } from '../../stores/slices/appViewDetailsSlice'
import { resetApplicationsDocLists } from '../../stores/slices/document/documentDownloadSlice'
import moment from 'moment'
function AppintakeCard({ flow }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedLanguage = useSelector(language).AppintakeCard
    const patientData = useSelector((state) => flow.flow == 'Claim' ? state.claimProcessSlice : state.patientSearchSlice.patientInformation)
    const restrictRoute = useSelector((state) => state.routeRestrictionSlice)
    const cancelNavigate = useSelector((state) => state.claimIntakeSlice.cancelNavigate)
    const appViewDetails = useSelector(state => state.appViewDetailsSlice)


    const [cacelFlowModal, setCancelFlowModal] = useState(false);
    const onClickCancelFlow = () => {
        dispatch(resetTreatingPhysician())
        // reset store data
        dispatch(setConditionalRoute({
            isFlag: false,
            currentFlow: '',
        }))
        setCancelFlowModal(false);
        dispatch(resetPreQualValidate())
        if (cancelNavigate) {
            // dispatch(resetAppViewDetails());
            // dispatch(resetApplicationsDocLists());
            // dispatch(resetInitialTab(1));
            dispatch(fetchViewAppDetails({ applicationID: appViewDetails.viewAppInfo.applicationId, prgData: appViewDetails.program }))
            dispatch(getMemberDetails({ memberId: appViewDetails.patientInfo.patientId, prgData: appViewDetails.program }))
            navigate('/applications/Details')
        } else {
            navigate('/createApp');
        }
    }

    return (
        <div className="intro-y box px-5  mt-5">
            <div className="d-flex flex-column flex-lg-row ">
                <div className="d-flex flex-1 py-4">
                    <div className="ms-1 pt-2">
                        <div className="py-1 px-5 rounded-pill fs-xs bg-theme-9 text-white cursor-pointer fw-medium">{flow.flow === 'Claim' ? patientData.applicationID : patientData.programSpecificPatientId != '' ? patientData.programSpecificPatientId : selectedLanguage.newPatient}</div>
                    </div>
                </div>
                <div className="d-flex flex-1 py-4">
                    <div className="ms-1">
                        <div className="fw-medium">{patientData.firstName} {patientData.lastName}</div>
                        <div className="text-gray-600">{patientData.Program == "CPR" ? "TotalAssist" : patientData.Program}</div>
                    </div>
                </div>
                <div className="d-flex flex-1  py-4">
                    <div className="ms-1">
                        <div className="fw-medium">{selectedLanguage.DOB}</div>
                        <div className="text-gray-600">{ flow.flow === 'Claim' ? patientData.dob :  `${patientData.dateOfBirth.substring(5, 7)}/${patientData.dateOfBirth.substring(8, 10)}/${patientData.dateOfBirth.substring(0, 4)}`}</div>
                    </div>
                </div>
                <div className="d-flex flex-1 py-4">
                    <div className="ms-1">
                        <div className="fw-medium">{selectedLanguage.SSNorAlienNumber}</div>
                        <div className="text-gray-600">{patientData.ssn != '' && typeof patientData.ssn != 'undefined' && patientData.ssn != "--" ? maskData('SSN', patientData.ssn) : maskData('Alien', patientData.alienNumber)}</div>
                    </div>
                </div>
                <div className="d-flex flex-1 py-4">
                    <div className="ms-1">
                        <div className="fw-medium">{selectedLanguage.phoneNumber}</div>
                        <div className="text-gray-600">{patientData.contactDetails.phoneNumber}</div>
                    </div>
                </div>
                <div className="d-flex flex-1 py-4 ">
                    <button className="w-42 btn btn-yellow align-items-center" onClick={() => setCancelFlowModal(true)}>{`Cancel ${restrictRoute.conditionalRouteFlow}`} </button>

                </div>
            </div>
            <Modal
                title=''
                open={cacelFlowModal}
                onCancel={() => setCancelFlowModal(false)}
                onOk={onClickCancelFlow}
                okText={'Yes'}
                cancelText={'No'}
                maskClosable={false}
                closable={false}
            >
                <span className='modal_style'> Would you like to cancel your {restrictRoute.conditionalRouteFlow} request ? </span>
            </Modal>
        </div>
    )
}

export default AppintakeCard